import {
  normalizePriceWatchState,
  type PriceWatchRuleDraft,
  type PriceWatchState,
} from "./price-watch-model";

export class PriceWatchApiError extends Error {
  constructor(
    readonly code: string,
    readonly status: number,
  ) {
    super(code);
    this.name = "PriceWatchApiError";
  }
}

async function request(
  initData: string,
  action: string,
  data: Record<string, unknown> = {},
): Promise<PriceWatchState> {
  const response = await fetch("/api/price-watches", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ initData, action, ...data }),
  });
  let body: Record<string, unknown>;
  try {
    body = (await response.json()) as Record<string, unknown>;
  } catch {
    throw new PriceWatchApiError("invalid_response", response.status);
  }
  const state = normalizePriceWatchState(body.state);
  if (!response.ok || body.ok !== true || !state) {
    throw new PriceWatchApiError(
      typeof body.error === "string" ? body.error : "price_watch_failed",
      response.status,
    );
  }
  return state;
}

export function loadPriceWatches(initData: string): Promise<PriceWatchState> {
  return request(initData, "list");
}

export function savePriceWatch(
  initData: string,
  rule: PriceWatchRuleDraft,
): Promise<PriceWatchState> {
  return request(initData, "save", { rule });
}

export function deletePriceWatch(
  initData: string,
  ruleId: string,
): Promise<PriceWatchState> {
  return request(initData, "delete", { ruleId });
}

export function togglePriceWatch(
  initData: string,
  ruleId: string,
  enabled: boolean,
): Promise<PriceWatchState> {
  return request(initData, "toggle", { ruleId, enabled });
}

export function markPriceAlertsRead(
  initData: string,
  eventIds: readonly string[],
): Promise<PriceWatchState> {
  return request(initData, "mark-read", { eventIds });
}
